import { FlexContainer, Skeleton } from '@placer-ui/components';
import React from 'react';
import styles from './chip-list.module.scss';

interface ChipListSkeletonProps {
    testId: string;
    optionsCount?: number;
}

export const ChipListSkeleton = ({ optionsCount = 3, testId }: ChipListSkeletonProps) => {
    return (
        <FlexContainer testId={testId} flexDirection="column" gap={8}>
            {[...Array(optionsCount).keys()].map((item) => (
                <div className={styles.chipListItem} key={item}>
                    <FlexContainer
                        height={32}
                        justifyContent="center"
                        flexDirection="column"
                        gap={6}
                    >
                        <Skeleton isVisible={true} height={12} width="40%" />
                        <Skeleton isVisible={true} height={12} width="100%" />
                    </FlexContainer>
                </div>
            ))}
        </FlexContainer>
    );
};
